export default __webpack_public_path__ + "static/media/pause.837bec9b.png";